import { render, staticRenderFns } from "./platinfouser-add-or-update.vue?vue&type=template&id=064e8bf8&"
import script from "./platinfouser-add-or-update.vue?vue&type=script&lang=js&"
export * from "./platinfouser-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports